import { ReactElement } from 'react'

import { EInvoicingGetStarted } from '../elements/EInvoicingGetStarted'
import { EInvoicingKYCApproved } from '../elements/EInvoicingKYCApproved'
import { EInvoicingKYCPending } from '../elements/EInvoicingKYCPending'
import { EInvoicingKYCRefused } from '../elements/EInvoicingKYCRefused'
import { KYCStatus } from '../types'

export const eInvoicingKycStatusToComponentMapping: Partial<Record<KYCStatus, ReactElement>> = {
  KYC_APPROVED: <EInvoicingKYCApproved />,
  KYC_PENDING_DOCUMENTS: <EInvoicingGetStarted />,
  KYC_PENDING_VALIDATION: <EInvoicingKYCPending />,
  KYC_PENDING_OPT_IN: <EInvoicingGetStarted />,
  KYC_PENDING_REVIEW_CREATION: <EInvoicingKYCPending />,
  KYC_REJECTED: <EInvoicingKYCRefused />,
  KYC_PENDING_COMPANY_ID: <EInvoicingKYCPending />,
}
